import { StandardEvents } from '@shopify/events';

class TrinityCartStatus extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.revision = 0;
    const { signal } = this.controller;
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate, { signal });
    window.addEventListener('pageshow', this.onPageShow, { signal });
  }

  disconnectedCallback() {
    this.controller.abort();
    this.refreshController?.abort();
    clearTimeout(this.timer);
  }

  renderCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    this.querySelector('[data-cart-count]').textContent = String(count);
  }

  onCartUpdate = (event) => {
    this.revision += 1;
    this.refreshController?.abort();
    if (!event.promise) {
      this.refresh();
      return;
    }
    event.promise.then(({ cart, detail } = {}) => {
      if (!this.isConnected) return;
      this.revision += 1;
      this.refreshController?.abort();
      if (Number.isInteger(cart?.totalQuantity)) {
        this.renderCount(cart.totalQuantity);
      } else {
        this.refresh();
      }
      if (event.action === 'add' && !detail?.didError) {
        const confirmation = this.querySelector('.tri-cart-confirmation');
        confirmation.hidden = false;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => { confirmation.hidden = true; }, 4500);
      }
    }).catch(() => { if (this.isConnected) this.refresh(); });
  };

  onPageShow = (event) => {
    if (event.persisted) this.refresh();
  };

  async refresh() {
    this.refreshController?.abort();
    this.refreshController = new AbortController();
    const revision = this.revision;
    try {
      const response = await fetch(this.dataset.cartUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: this.refreshController.signal,
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (this.isConnected && revision === this.revision) this.renderCount(cart.item_count);
    } catch {}
  }
}

if (!customElements.get('trinity-cart-status')) {
  customElements.define('trinity-cart-status', TrinityCartStatus);
}
